<template>
  <div class="mainContent">
    <img
      class="back"
      @click="goHome"
      v-lazy="require('./../../../assets/img/back2.png')"
    />
    <div>点击右上角<strong>【发送给好友】</strong></div>
    <div>
      赠送<strong>《{{ test }}》</strong>给好友
    </div>
    <div class="des">
      <div>.每份测评仅供1人领取一次。</div>
      <div>
        .若因系统问题导致赠送失败，请直接<van-button
          type="default"
          v-clipboard:copy="localUrl + '#/my/send/' + code"
          v-clipboard:success="copy"
          v-clipboard:error="copyError"
          style="
            background: rgba(247, 189, 0, 0.6) !important;
            border-radius: 5px;
            padding: 2px !important;
            margin: 0 2px;
            height: 0.8rem;
          "
          class="popbtn bgblue mb-20 code_copy newClass"
          >{{ success ? "复制成功" : "复制链接" }}</van-button
        >发送给好友
      </div>
    </div>
    <img v-lazy="require('./../../../assets/img/test/bg_exchange.png')" />
  </div>
</template>

<script>
import sdk from "../../../mixin/share";
import { mapGetters } from "vuex";
import { getTestDetail } from "@/http/api";
export default {
  name: "sendDetail",
  data() {
    return {
      test: "",
      success: false,
      code: "",
      localUrl: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.code = this.$route.path.split("sendDetail/")[1] || "";
    let eval_id = localStorage.testId || "";
    getTestDetail("" + eval_id).then((res) => {
      this.test = res.data.title;
      this.localUrl = window.location.href.split("#")[0];
      const dataForWeixin = {
        title: `${this.user.nick_name}赠送你一份${res.data.title}给你`, // 分享标题
        desc: res.data.intro, // 分享内容
        linkurl: `${this.localUrl}#/my/send/${this.code}`, // 分享链接
        img: res.data.home_image, // 分享内容显示的图片(图片必须是正方形的链接)
      };
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        sdk.getJSSDK(dataForWeixin);
      }
    });
  },
  methods: {
    // 复制兑换码
    copy(e) {
      this.$message({
        message: "复制成功",
        type: "success",
      });
      this.success = true;
    },
    copyError(e) {
      this.$message({
        message: "复制失败",
        type: "error",
      });
      // alert('复制失败')
      this.success = false;
    },
    goHome() {
      this.$router.push("/my/send");
    },
  },
};
</script>
<style lang="less" scoped>
.mainContent {
  padding: 40px 50px;
  font-size: 20px;
  line-height: 30px;
  .des {
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 12px;
    line-height: 20px;
    color: #555;
  }
}

.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
</style>
